import { css } from '@emotion/css';

export const embeddedVideoCss = css`
  width: 100%;
`;
